import {
    FC,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
  } from "react";

const useDebouncedCallback = (callback: any, delay: any) => {
    const debounceRef = useRef<any>({});
  
    const debouncedCallback = useCallback(
      (...args: any[]) => {
        clearTimeout(debounceRef.current.timer);
        debounceRef.current.timer = setTimeout(() => {
          callback(...args);
        }, delay);
      },
      [callback, delay]
    );
  
    useEffect(() => {
      const timer = debounceRef.current.timer;
      return () => {
        clearTimeout(timer);
      };
    }, []);
  
    return debouncedCallback;
  };
  
  export default useDebouncedCallback;